export const firstFeatureContent = {
    title: () => (
      <>
        Enjoy{" "}
        <span
          className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
          style={{ color: "#6E4CD1" }}
        >
          real-time betting
        </span>{" "}
        action
      </>
    ),
    items: [
      "Automated payouts",
      "Fast funds withdrawal",
      "Low commissions",
      "Wide range of betting options",
      "Just connect wallet to start betting",
    ],
  };
  export const secondFeatureContent = {
    title: () => (
      <>
        Easy to{" "}
        <span
          className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
          style={{ color: "#6E4CD1" }}
        >
          use and fun
        </span>{" "}
        experience
      </>
    ),
    items: [
      "User-friendly interface",
      "Mobile version supported",
      "Knowledge base",
      "Community Contests",
      "Demo account with virtual money",
    ],
  };
  export const thirdFeatureContent = {
    title: () => (
      <>
        Use{" "}
        <span
          className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
          style={{ color: "#6E4CD1" }}
        >
          reliable and trustworthy
        </span>{" "}
        platform
      </>
    ),
    items: [
      "On-chain betting options",
      "Automated payouts via blockchain",
      "Binance as data provider",
    ],
  };
